import React, { useEffect } from 'react';

import { useRecoilValue, useSetRecoilState, RecoilState } from 'recoil';
import { FormControl } from '@tq/ui-components';

import { ConsultationFilterMultiSelect, TableCellBadges } from 'components';
import { ValueLabelResponse } from 'types';

interface TeamsTableCellProps {
  rowValue: ValueLabelResponse[];
  editingState: RecoilState<number | undefined>;
  teamState: RecoilState<ValueLabelResponse[]>;
  rowIndex: number;
  label: string;
  options: ValueLabelResponse[];
}

export const TeamsTableCell: React.FC<TeamsTableCellProps> = ({
  rowValue,
  editingState,
  teamState,
  rowIndex,
  label,
  options,
}) => {
  const currentEditRowIndex = useRecoilValue(editingState);
  const setTeamsState = useSetRecoilState(teamState);

  useEffect(() => {
    if (currentEditRowIndex === rowIndex) {
      if (rowValue.length) setTeamsState(rowValue);
    }
  }, [rowValue, currentEditRowIndex, rowIndex, setTeamsState]);

  return currentEditRowIndex === rowIndex ? (
    <FormControl width='100%'>
      <ConsultationFilterMultiSelect
        fieldId='teams'
        label={label}
        items={options}
        state={teamState}
      />
    </FormControl>
  ) : (
    <TableCellBadges items={rowValue} />
  );
};
